import script from "./BaseColorpicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseColorpicker.vue?vue&type=script&setup=true&lang=ts"

import "./BaseColorpicker.vue?vue&type=style&index=0&id=f59e9ae2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f59e9ae2"]])

export default __exports__